import React from 'react';
import { FormattedMessage } from 'react-intl';

// import get from 'lodash/get';

// import judgeTaaka from 'assets/judge-taaka.png';
// import judgeCarl from 'assets/judge-carl.png';
// import judgeGima from 'assets/judge-gima.png';
// import judgeHibb from 'assets/judge-hibb.png';
// import judgeKennedy from 'assets/judge-kennedy.png';
// import judgeMamadou from 'assets/judge-mamadou.png';
// import judgeRakesh from 'assets/judge-rakesh.png';
// import judgeVuyiswa from 'assets/judge-vuyiswa.png';
import PageTitle from 'shared/PageTitle';
import Text from 'ui/Text';

const Judges = () => (
  <div id="judges">
    <PageTitle title="Judges" />
    <div>
      <div className="inner-content about-explainer bg-light-orange">
        <Text type="heading-semi-bold" modifiers="text-center title heavy">
          <FormattedMessage
            id="Why.Participate"
            defaultMessage="Why complete the African CSO Assessment?"
          />
          <span className="fake-border fake-border__underline center-block bg-pure-white" />
        </Text>
        <div className="col-sm-12 col-md-9 col-lg-9 center-block">
          <Text type="explainer" modifiers="explanations-area plain-message text-center">
            <FormattedMessage
              id="Why.Explanation"
              defaultMessage="
              An excellent opportunity to evaluate your organization’s challenges and strengths.
              Build your visibility and increase your credibility by appearing in the African CSO
database.
Receive a comprehensive Capacity Diagnostic Report on your organization’s capacity.
This can serve as a benchmark and a conversation starter with potential funders about
strengthening your organization, and
contribute to increased data and actionable knowledge about the African CSO sector.
                  "
            />
          </Text>
        </div>
      </div>
    </div>
  </div>
);

export default Judges;



// WEBPACK FOOTER //
// ./src/components/HomePage/Judges.js